import { berthApiClient } from '../berthApiClient'

import { getAttachmentDriverFileEndpoint } from './endpoint'

export const getAttachmentDriverFile = (id: number | string): Promise<{ data: Blob }> =>
  berthApiClient.get(getAttachmentDriverFileEndpoint, {
    params: { id },
    responseType: 'blob',
    headers: { 'Content-Type': 'application/octet-stream' },
  })
